import { createContext } from 'react';

interface ActiveStepContextValue {
  activeStepUrl: string | undefined;
}

const ActiveStepContext = createContext<ActiveStepContextValue>({
  activeStepUrl: undefined
});

export default ActiveStepContext;
